export const backendUrl = "https://ecelocker.onrender.com";
// export const backendUrl = "http://localhost:4000";
export const clustersSize = 6;
export const resultUrl = "https://nith-results-default-rtdb.firebaseio.com";
